module.exports = __webpack_public_path__ + "img/logo.85c54114.png";